module.exports = __webpack_public_path__ + "img/Security_of_DLT_Networks.2635076f.jpg";